<template>
    <v-container fluid class="px-0">
		<v-form ref="form">
			<v-row>
				<v-col cols="12">   
					<v-select 
						v-model="typeId"
						:items="types"
						item-text="name"
						item-value="id"
						menu-props="bottom, offsetY"
						:label="targetLabel" 
						/>              
				</v-col>
				<v-col cols="12" v-if="typeId === 1">
					<v-select 
						v-model="workplaceIds"
						chips
						multiple
						deletable-chips
						:items="filterByProfile ? workplacesByProfile : workplaces"
						item-text="name"
						item-value="id"
						menu-props="bottom, offsetY"
						:label="$t('wkt.admin.activity-types.edit-activity-types.workplaces')"
						/>
				</v-col>
				<v-col cols="12" v-if="typeId === 1">
					<v-select
						v-model="departmentIds"
						chips
						multiple
						deletable-chips
						:items="filterByProfile ? departmentsByProfile : departments"
						item-text="name"
						item-value="id"
						menu-props="bottom, offsetY"
						:label="$t('wkt.admin.activity-types.edit-activity-types.departments')"
						/>
				</v-col>
				<v-col cols="12" v-if="typeId === 2">
					<v-select
						v-model="projectIds"
						chips
						multiple
						deletable-chips
						:items="projects"
						:item-text="item => `${item.shortName} - ${item.description}`"
						item-value="id"
						menu-props="bottom, offsetY"
						:label="$t('wkt.admin.activity-types.edit-activity-types.access-type_project')"
						/>
				</v-col>
				<v-col cols="12" v-if="typeId === 3">
					<v-autocomplete
						v-model="employeeIds"
						chips
						multiple
						clearable
						deletable-chips
						:items="employees"
						:item-text="item => `${item.lastname}, ${item.firstname} ${!item.isEnabled ? ` (${this.$t('wkt.admin.edit-employee-window.disabled')})` : ''}`"
						item-value="id"
						:filter="filterEmployees"
						menu-props="bottom, offsetY"
						:label="$t('wkt.admin.common.filters.employee_placeholder')"
						:placeholder="$t('wkt.admin.common.filters.employee_placeholder')"
                        :rules="[validationRules.requiredMultiple]" />
				</v-col>
			</v-row>
		</v-form>
    </v-container>
</template>

<script>
import BaseModule from './BaseModule.js';
import api from '../../api/worktime.js';
import gwt from '../../api/gwt.js';

export default {
	name: 'TargetManager',
	mixins: [BaseModule],
	props: ['types', 'filterByProfile', 'selectedIds', 'isProject', 'targetLabel', 'workplaceIdsAsString', 'departmentIdsAsString', 'projectIdsAsString', 'employeeIdsAsString'],
	components: {
	},
	watch: {
		selectedIds: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!this.companyId || (this.companyId && gwt.getSessionInformation().company.id !== this.companyId)) {
					this.companyId = gwt.getSessionInformation().company.id;

					this.getDepartments();
					this.getWorkplaces();
					if (!this.isProject) {
						this.getProjects();
					}
				}

				this.typeId = 0;
				this.workplaceIds = [];
				this.departmentIds = [];
				this.projectIds = [];
				this.employeeIds = [];
			}
		},
		filterByProfile: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (oldValue && newValue !== oldValue) {
					this.getDepartments();
					this.getWorkplaces();
				}
			}
		},
		workplaceIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.workplaceIds = [];
					return;
				}
					
				this.workplaceIds = newValue.split(',').map(Number);
			}
		},
		departmentIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.departmentIds = [];
					return;
				}
					
				this.departmentIds = newValue.split(',').map(Number);
			}
		},
		projectIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.projectIds = [];
					return;
				}
					
				this.projectIds = newValue.split(',').map(Number);
			}
		},
		employeeIdsAsString: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!newValue || newValue.length === 0) {
					this.employeeIds = [];
					return;
				}
					
				this.employeeIds = newValue.split(',').map(Number);
			}
		}
	},
	data () {
		return {
			typeId: 0,
			companyId: null,
			workplaceIds: [],
			departmentIds: [],
			projectIds: [],
			employeeIds: [],
			workplaces: [],
			workplacesByProfile: [],
			departments: [],
			departmentsByProfile: [],
			employees: [],
			projects: []
		}
	},
	mounted() {
	},
	methods: {
		getWorkplaces() {
			this.workplaces = this.filterByProfile ? gwt.getWorkplacesByProfile() : gwt.getWorkplaces();
			
			if (this.workplaces) {
				return;
			}

			api.getWorkPlaces(
				(data) => {
					this.workplaces = data;
					if (this.filterByProfile) {
						this.filterWorplacesByProfile();
					}
				}, 
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
			);
		},
		getDepartments() {
			this.departments = this.filterByProfile ? gwt.getDepartmentsByProfile() : gwt.getDepartments();
			
			if (this.departments) {
				this.getAllEmployees();
				return;
			}

			api.getStaff(
				(data) => {
					this.departments = data;
					if (this.filterByProfile) {
						this.filterDepartmentsByProfile();
					}
					this.getAllEmployees();
				}, 
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
			);
		},
		getProjects() {
			api.getProjects(
				(data) => {
					this.projects = data;
				}, 
				(error) => {
					this.loading = false;
					this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
				}
			);
		},		
		getAllEmployees() {
			this.employees = [];

			for (const department of this.departments) {
				this.employees = [...this.employees, ...department.employees];
			}

			this.employees.sort((a,b) => {
				const fullnameA = this.getEmployeeFullname(a).toLowerCase();
				const fullnameB = this.getEmployeeFullname(b).toLowerCase();
				if (fullnameA == fullnameB) return 0;
				if (fullnameA > fullnameB) return 1;
				return -1;
			});
		},
		// eslint-disable-next-line no-unused-vars
		filterEmployees(item, queryText, itemText) {
			const normalizedFirstname = item.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			const normalizedLastname = item.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			const normalizedQueryText = queryText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

			return normalizedFirstname.indexOf(normalizedQueryText) > -1 || 
				normalizedLastname.indexOf(normalizedQueryText) > -1;
		},
		filterWorplacesByProfile() {
			this.workplacesByProfile = [];

			if (gwt.getSessionInformation()) {
				const profile = gwt.getSessionProfile();

				if (profile) {
					if (!profile.workplaces) {
						this.workplacesByProfile = this.workplaces;
					} else {
						if (profile.workplaces) {
							const workplaceIds = profile.workplaces.split(',');

							if (workplaceIds) {
								this.workplacesByProfile = this.workplaces.filter(x => workplaceIds.includes(x.id));
							}
						}
					}
				} else if (this.isEmulationEnabled()) {
					this.workplacesByProfile = this.workplaces;
				}
			}
		},
		filterDepartmentsByProfile() {
			this.departmentsByProfile = [];

			if (gwt.getSessionInformation()) {
				const profile = gwt.getSessionProfile();

				if (profile) {
					if (!profile.departments) {
						this.departmentsByProfile = this.departments;
					} else {
						if (profile.departments) {
							const departmentIds = profile.departments.split(',');

							if (departmentIds) {
								this.departmentsByProfile = this.departments.filter(x => departmentIds.includes(x.id));
							}
						}
					}
				} else if (this.isEmulationEnabled()) {
					this.departmentsByProfile = this.departments;
				}
			}
		},
		getProjectEmployeeIds() {
			let items = [];

			if (!this.$refs.form.validate()) {
				return items;
			}

			if (this.typeId === 0) { // 0 - Company
				items = [...this.employees];
			} else if (this.typeId === 1) { // 1 - Group
				if (this.workplaceIds.length === 0 && this.departmentIds.length === 0) {
					items = [...this.employees];
				} else if (this.workplaceIds.length > 0 && this.departmentIds.length > 0) {
					items = [...this.employees.filter(x => this.workplaceIds.includes(x.workplaceId) && this.departmentIds.includes(x.departmentId))];
				} else if (this.workplaceIds.length > 0 && this.departmentIds.length === 0) {
					items = [...this.employees.filter(x => this.workplaceIds.includes(x.workplaceId))];
				} else if (this.workplaceIds.length === 0 && this.departmentIds.length > 0) {
					items = [...this.employees.filter(x => this.departmentIds.includes(x.departmentId))];
				}
			} else if (this.typeId === 3) { // 3 - Employee
				items = [...this.employees.filter(x => this.employeeIds.includes(x.id))];
			} else if (this.typeId === 4) { // 4 - My team
				if (gwt.getSessionInformation().myTeam && gwt.getSessionInformation().myTeam.length > 0) {
					if (this.isProject) {
						const myTeamIds = gwt.getSessionInformation().myTeam.map(x => x.id);
						items = [...this.employees.filter(x => myTeamIds.includes(x.id))];
					} else {
						items = [...gwt.getSessionInformation().myTeam];
					}
				}
			}
			
			let itemIds = items.map(x => x.id);
		
			if (this.selectedIds.length > 0) {
				itemIds = [...itemIds.filter(x => !this.selectedIds.includes(x))];
			}

			return itemIds;
		}
	},
	getWorkplaceIds() {
		return this.workplaceIds;
	},
	getDepartmentIds() {
		return this.departmentIds;
	},
	getProjectIds() {
		return this.projectIds;
	},
	getEmployeeIds() {
		return this.employeeIds;
	},
	getMyTeamIds() {
		if (!gwt.getSessionInformation().myTeam) {
			return [];
		}
		return gwt.getSessionInformation().myTeam.map(x => x.id);
	},
	getWorkplaceIdsAsString() {
		if (this.workplaceIds.length === 0 || this.workplaceIds.length === this.workplacesByProfile.length) {
			return null;
		}

		return this.workplaceIds.toString();
	},
	getDepartmentsAsString() {
		if (this.departmentIds.length === 0 || this.departmentIds.length === this.departmentsByProfile.length) {
			return null;
		}

		return this.departmentIds.toString();
	},
	getProjectsAsString() {
		if (this.projectIds.length === 0) {
			return null;
		}

		return this.projectIds.toString();
	},
	getEmployeesAsString() {
		if (this.employeeIds.length === 0) {
			return null;
		}

		return this.employeeIds.toString();
	},
	getMyTeamAsString() {
		if (!gwt.getSessionInformation().myTeam || gwt.getSessionInformation().myTeam.length === 0) {
			return null;
		}

		return gwt.getSessionInformation().myTeam.map(x => x.id).toString();
	}
}
</script>